import { AllowedProblemPickPolicySchema } from "@redotech/redo-model/wms/allowed-problem-pick-policy";
import * as z from "zod";

export const getAllowedProblemPickPolicy = {
  name: "getAllowedProblemPickPolicy" as const,
  input: z.null(),
  output: z.object({ policy: AllowedProblemPickPolicySchema }),
};

export const updateAllowedProblemPickPolicy = {
  name: "updateAllowedProblemPickPolicy" as const,
  input: z.object({ policy: AllowedProblemPickPolicySchema }),
  output: z.object({ policy: AllowedProblemPickPolicySchema }),
};
